import React,{Component} from 'react';
import {connect} from "react-redux";
import "./style.less";
import {NavBar,Modal,Toast,Button} from "antd-mobile";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class PaySuccess extends Component{
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            showModal:false,
        };
    
    }
    componentDidMount() {
    
    }
   
    render(){
        return(
            <div className="paySuccess">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >支付成功</NavBar>
                <div className="select"><i className="icon iconfont iconxuanzhong"/></div>
                <div className="change">修改地址成功！</div>
                <div className="btn">点击返回</div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/PaySuccess/index.js